import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BtnCategoryIn } from "../minor.jsx";
import "./elements.css";

// Helper function for image paths
const getImageSrc = (file) => {
  if (!file) return "";
  const normalized = file.replace(/^(\.\.\/)+/, "");
  return `/images/${normalized}`;
};
export const Addnotation = () => {
  return (
    <div className="addMainWrap">
      <span>Tytł</span>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
        hendrerit neque sed diam molestie sollicitudin. Ut velit augue, laoreet
        faucibus eros vel, accumsan dictum sapien. Nullam justo dolor, pharetra
        id sem in, tristique aliquet lacus. Fusce vel pretium ex. Aliquam leo
        elit, iaculis at lectus nec, tincidunt malesuada metus. Aliquam a
        condimentum nisi, eget efficitur est. Sed vel pretium orci. Vivamus sit
        amet feugiat massa, a ullamcorper nunc. Ut pretium velit blandit,
        suscipit nibh semper, feugiat dolor.
      </p>
    </div>
  );
};

export const TopProdEl = ({
  id = "prod",
  img = "../course1.png",
  title = "Blender modeling.",
  tags = ["Modeling", "Product", "Subdivision"],
  desc = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
  hendrerit neque sed diam molestie sollicitudin.`,
  price = "49.99",
}) => {
  return (
    <div className="hmpfelWrap">
      <div className="hmpfelTop">
        <img alt="ayaya" src={img}></img>

        <div className="gradientHMF"></div>
      </div>
      <div className="hmpfelBot">
        <span>{title}</span>
        <div className="hmpfelBotTags">
          {tags.map((el) => {
            return <span>{el}</span>;
          })}
        </div>
        <span>{desc}</span>
        <span>Pirice: {price}$</span>
        <input type="button" value={"Sprawdź"} className="btnTopProdEl"></input>
      </div>
    </div>
  );
};
// BtnCategoryIn moved to minor.jsx
export const HubArticle = (props) => {
  const { authors = [] } = props;
  
  return (
    <Link
      to={`/article/${props.id}/${props.title.slice(0, -1).replace(/[\s:]+/g, '-').toLowerCase()}`}
    >
      <article className="hmpfmElWrap">
        <div className="categoriesNews">
          <BtnCategoryIn cat={props.category} key={"btnGrid"} />
        </div>
        <div className="BorderHoverNews">
          <img src="/newsElEfBorder.png" alt="artBorder"></img>
        </div>
        <div className="NewsEffects">
          <img src="/newsElEf.png" alt="artBG"></img>
        </div>
        <div className="hmpfmElBG">
          <div className="hmpfmElIntLeftWrap">
            <div className="gradientNwsBG"></div>
            <div className="gradientNwsBG"></div>
            <img src={`/${props.img}`} alt="news"></img>
          </div>
          <aside className="hmpfmElIntRightWrap">
            <div className="hmpfmElIntRight">
              {/* <div className="hmpfmElIntRightT">
              <span></span>
              <span>22.02.2023</span>
            </div> */}
              <div className="hmpfmElIntRightB">
                <span>{props.title}</span>
                <span>
                  22.02.2023 ~ added by -{" "}
                  {props.authorId != null ? (
                    <span>{authors[props.authorId]?.nickname}</span>
                  ) : (
                    <span>admin</span>
                  )}
                </span>
              </div>
            </div>
          </aside>
        </div>
      </article>
    </Link>
  );
};
export const HubArticleV2 = (props) => {
  const { authors = [] } = props;
  
  return (
    <Link
      to={`/article/${props.id}/${props.title.slice(0, -1).replace(/[\s:]+/g, '-').toLowerCase()}`}
    >
      <article className="hmpfmElWrap">
        <div className="hmpfmElBG2">
          <div className="hmpfmElIntLeftWrap">
            <div className="gradientNwsBG"></div>
            {/* <div className="gradientNwsBG"></div> */}
            <img src={`/${props.img}`} alt="news"></img>
            <div className="categoriesNews">
              <BtnCategoryIn cat={props.category} key={"btnGrid"} />
            </div>
          </div>
          <aside className="hmpfmElIntRightWrap">
            <div className="hmpfmElIntRight">
              {/* <div className="hmpfmElIntRightT">
              <span></span>
              <span>22.02.2023</span>
            </div> */}
              <div className="hmpfmElIntRightB">
                <span>
                  22.02.2023 |{" "}
                  {props.authorId != null ? (
                    <span>{authors[props.authorId]?.nickname}</span>
                  ) : (
                    <span>admin</span>
                  )}
                </span>
                <span>{props.title.slice(0, 20)}</span>
                <p>{props.content.slice(0, 100)}</p>
              </div>
            </div>
          </aside>
        </div>
      </article>
    </Link>
  );
};
export const BasicArticle = (props) => {
  const { authors = [] } = props;
  
  return (
    <div className="DFDvcA">
      <div className="BGTnhn">
        <img src={props.img} alt="artImg"></img>
      </div>
      <div className="BGTnhg">
        <div>
          <span>{props.title}</span>
          <span>
            22.02.2023 ~ added by -{" "}
            {props.authorId != null ? (
              <span>{authors[props.authorId]?.nickname}</span>
            ) : (
              <span>admin</span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
export const NewsArticleBlock = (props) => {
  return (
    <div className="pEoMrK">
      <div className="uXwYiP">
        <span className="artTitle1">{props.title}</span>
        <div className="cKjDoS">
          <img src={props.img} alt="art"></img>
        </div>
      </div>
      <p>{props.content}</p>
    </div>
  );
};
export const TopElSliderChild = ({ scr, cr, img }) => {
  return (
    <div className="dSpAbE">
      <div className="iMzWoX" style={{ backgroundImage: `url(${img})` }}>
        {/* <img src="../bg1.png"></img> */}
      </div>
      <div className="nIuQyL">
        <div
          className="lVdCsB"
          style={{ backgroundImage: `url(${img})` }}
        ></div>
        <div className="gZqHuX">
          <span>Lorem ispun</span>
          <span>
            Lorem ispum alos dolaros bakus z wakus meaningful text, or an empty
            string for decorative images
          </span>
        </div>
      </div>
      <div className="jRcEfK" style={{ backgroundImage: `url(${img})` }}></div>
      <div className="hRgFjX">
        <div className="tGjZoU">
          {Array(4)
            .fill(null)
            .map((el, i) => {
              return <TopElSliderChildBtn value={i} scr={scr} cr={cr} />;
            })}
        </div>
      </div>
    </div>
  );
};
const TopElSliderChildBtn = ({ value, scr, cr }) => {
  return (
    <button
      className={`oDnAqY ${cr === value ? "oDnAqY_Active" : ""}`}
      onClick={() => {
        scr(value);
      }}
    >
      <div className="mVbCsL"></div>
    </button>
  );
};
export const BridgeHMPF = ({ theme }) => {
  switch (theme) {
    case 1:
      return (
        <div className="bridgeMNW">
          <div className="uOgDhB"></div>
          <div className="eHvQtU">
            <div className="kXpUvR">
              <div className="aZcWoE"></div>
              <div className="aZcWoE"></div>
            </div>
            <div className="zLwNsM"></div>
            <div className="xQyIkO"></div>
            <div className="zLwNsM"></div>
            <div className="kXpUvR">
              <div className="aZcWoE"></div>
              <div className="aZcWoE"></div>
            </div>
          </div>
          <div className="uOgDhB"></div>
        </div>
      );
    case 2:
      return (
        <div className="bridgeMNW">
          <div className="ergERG">
            <div className="gfdqwW"></div>
            <div className="gfdqwW"></div>
          </div>
          <div className="uOgDhB"></div>
          <div className="uOgDhB"></div>
          <div className="ergERG">
            <div className="gfdqwW"></div>
            <div className="gfdqwW"></div>
          </div>
        </div>
      );
    case 3:
      return (
        <div className="bridgeMNW">
          <div className="ergERG">
            <div className="gfdqwW"></div>
            <div className="gfdqwW"></div>
          </div>
          <div className="uOgDhB"></div>
          <div className="eHvQtU">
            <div className="kXpUvR">
              <div className="aZcWoE"></div>
              <div className="aZcWoE"></div>
            </div>
            <div className="zLwNsM"></div>
            <div className="xQyIkO"></div>
            <div className="zLwNsM"></div>
            <div className="kXpUvR">
              <div className="aZcWoE"></div>
              <div className="aZcWoE"></div>
            </div>
          </div>
          <div className="uOgDhB"></div>
          <div className="ergERG">
            <div className="gfdqwW"></div>
            <div className="gfdqwW"></div>
          </div>
        </div>
      );
    case 4:
      return (
        <div className={`bridgeMNW${theme}`}>
          <div className={`ergERG${theme}`}>
            <div className="gfdqwW"></div>
            <div className="gfdqwW"></div>
          </div>
          <div className="SDbdWR">
            {" "}
            <div>
              {" "}
              <div className="snEFWf"></div>
              <div className="snEFWf"></div>
            </div>
          </div>
          <div className="fASDaf"></div>
          <div className="fASDjm">
            <div className="rweCWC"></div>
            <div className="WEFqqD">
              <div className="Fdssfd"></div>
              <div className="FdssGG"></div>
              <div className="Fdssfd"></div>
              <div className="FdssGG"></div>
              <div className="Fdssfd"></div>
              <div className="FdssGG"></div>
              <div className="Fdssfd"></div>
              <div className="FdssGG"></div>
              <div className="Fdssfd"></div>
              <div className="FdssGG"></div>
              <div className="Fdssfd"></div>
            </div>
            <div className="rweCWC"></div>
          </div>
          <div className="fASDaf"></div>
          <div className="SDbdWR">
            <div>
              {" "}
              <div className="snEFWf"></div>
              <div className="snEFWf"></div>
            </div>
          </div>
          <div className={`ergERG${theme}`}>
            <div className="gfdqwW"></div>
            <div className="gfdqwW"></div>
          </div>
        </div>
      );
    case 5:
      return (
        <div className={`bridgeMNW`}>
          <div className="uOgDhB"></div>
          <div className="aFAKRTy">
            <div className="kXpUvR">
              <div className="aZcWoE"></div>
              <div className="aZcWoE"></div>
            </div>
            <div className="box1"></div>
            <div className="box1"></div>
            <div className="box1"></div>
            <div className="kXpUvR">
              <div className="aZcWoE"></div>
              <div className="aZcWoE"></div>
            </div>
          </div>
          <div className="uOgDhB"></div>
        </div>
      );
    case 6:
      return (
        <div className={`bridgeMNW${theme}`}>
          <div className="aFAamnR"></div>
          <div className="uOgDhB"></div>
          <div className="aFAamnR"></div>
        </div>
      );
    case 7:
      return (
        <div className={`bridgeMNW${theme}`}>
          <div className="FJYJjy">
            <div className="DAfamn"></div>
            <div className="DAfamn"></div>
          </div>
          <div className="mHrCqL"></div>
          <div className="FJYJjy">
            <div className="DAfamn"></div>
            <div className="DAfamn"></div>
          </div>
        </div>
      );
    case 8:
      return (
        <div className={`bridgeMNW${theme}`}>
          <div className="aFAamnR"></div>
          <div className="aFAamnR"></div>
          <div className="uOgDhB"></div>
          <div className="aFAamnR"></div>
          <div className="aFAamnR"></div>
        </div>
      );
    default:
      return null;
  }
};
export const CategoriesPoll = ({ categories }) => {
  const [clickedCategories, setClickedCategories] = useState([]);

  const handleCategoryClick = (category) => {
    if (clickedCategories.includes(category)) {
      setClickedCategories((prevState) =>
        prevState.filter((cat) => cat !== category)
      );
    } else {
      setClickedCategories((prevState) => [...prevState, category]);
    }
  };
  return (
    <div className="weWECw">
      {categories.map((el) => {
        return (
          <BtnCategory
            key={el}
            el={el}
            handleClick={handleCategoryClick}
            isClicked={clickedCategories.includes(el)}
          />
        );
      })}
    </div>
  );
};
const BtnCategory = ({ el, handleClick, isClicked }) => {
  return (
    <div
      functionality="button"
      className={`${!isClicked ? "qwEQwrq" : "qwEQwrq qwEQwrq_Active"}`}
      onClick={() => handleClick(el)}
    >
      {/* <div className={`dasDAW nctg_${el}`}> */}
      <div className={`dasDAW2`}>
        <span>{el}</span>
      </div>
    </div>
  );
};

export const UserProf = ({ article, v, authors = [], news = [], categories = [] }) => {
  
  return article.authorId != null ? (
    <>
      <div className="rthgnbmnG">
        <div className="vCXzdVs">
          <img
            src={`/${authors[article.authorId]?.profilePic}`}
            alt="pd"
            className="profPic"
          />
          <span>{authors[article.authorId]?.nickname}</span>
          <div className="qwpoxzmnjhS">
            <div className="vfcdxsZA">
              <img
                src={`/${authors[article.authorId]?.profilePic}`}
                alt="pd"
                className="profPicV2"
              />
              <div className="VbcxdsFS">
                <span>{authors[article.authorId]?.nickname}</span>
                <p>{authors[article.authorId]?.bio}</p>
              </div>
            </div>
            <div className="vfVDdfnll">
              <span>Favourite categories:</span>
              <div className="cWEQWbqweq">
                <BtnCategoryIn
                  cat={[categories[0], categories[3], categories[6]]}
                />
              </div>
            </div>
            <div className="caooBVx">
              <div className="qNzPeCA">
                <span>Articles:</span>
                <span>
                  {
                    news.filter(
                      (art) =>
                        art.authorId === article.authorId &&
                        art.articleType === "info"
                    ).length
                  }
                </span>
              </div>
              <div className="qNzPeCA">
                <span>Tutorials:</span>
                <span>
                  {
                    news.filter(
                      (art) =>
                        art.authorId === article.authorId &&
                        art.articleType === "tuto"
                    ).length
                  }
                </span>
              </div>
              <div className="qNzPeCA">
                <span>42</span>
              </div>
            </div>
          </div>
        </div>
        {v === 1 ? <span className="dateCon">{article.date}</span> : null}
      </div>
    </>
  ) : (
    <>
      <span>admin</span>
    </>
  );
};

export const ContnetList = ({ art }) => {
  const [readArticles, setReadArticles] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const articles = document.querySelectorAll(".vbAQEZXC");
      const visibleArticles = Array.from(articles).filter((article) => {
        const rect = article.getBoundingClientRect();
        const articleId = article.id;
        const isAlreadyRead = readArticles.includes(articleId);
        return rect.top <= 0 && !isAlreadyRead;
      });
      const visibleArticleIds = visibleArticles.map((article) => article.id);
      setReadArticles((prevReadArticles) => [
        ...new Set([...prevReadArticles, ...visibleArticleIds]),
      ]);

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      const isScrollingUp = scrollTop < prevScrollTop;
      if (isScrollingUp) {
        setReadArticles((prevReadArticles) => {
          const newReadArticles = [...prevReadArticles];
          newReadArticles.pop();
          return newReadArticles;
        });
      }
      prevScrollTop = scrollTop;
    };

    let prevScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [readArticles]);

  return (
    <>
      <span className="titleContM">{art.title}</span>
      {art.articleData.map((article, i) => (
        <span
          key={i}
          id={i}
          className={`titleCont ${
            readArticles[i] === i.toString() ? "read" : ""
          }`}
        >
          {article.artCompType === 2 && "Tutorial: "}
          {article.title}
          {article.artCompType === 2 && (
            <div className="asdvxqwqQQ">
              {article.tutorialList.tutList.map((el, i) => (
                <span>{`Step ${i + 1}: ${el}`}</span>
              ))}
            </div>
          )}
        </span>
      ))}
    </>
  );
};
const sections = [
  "Games",
  "WebApplications",
  "3DModeling",
  "Assets",
  "Animation",
  "Architecture",
  "Software",
];
export const DiagonalSider = () => {
  return (
    <div className="DiagonalSliderWrap">
      {sections.map((el, i) => {
        return (
          <div className="hgjASDlk">
            <div className="gradientDS"></div>
            <div className="xzazlFGHJKj">
              <div className="qsqdwfwWDW">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Quisque hendrerit neque sed diam molestie sollicitudin. Ut
                  velit augue, laoreet faucibus eros vel, accumsan dictum
                  sapien. Nullam justo dolor, pharetra id sem in, tristique
                  aliquet lacus. Fusce vel pretium ex. Aliquam leo elit, iaculis
                  at lectus nec, tincidunt m
                </p>
              </div>
              <span className="zaqmnZXfffDS">{el}</span>
            </div>
          </div>
        );
      })}
      {/* <div className="hgjASDlk" style={{ backgroundColor: "blue" }}></div>
      <div className="hgjASDlk" style={{ backgroundColor: "red" }}></div>
      <div className="hgjASDlk" style={{ backgroundColor: "violet" }}></div>
      <div className="hgjASDlk" style={{ backgroundColor: "blue" }}></div>
      <div className="hgjASDlk" style={{ backgroundColor: "green" }}></div>
      <div className="hgjASDlk" style={{ backgroundColor: "yellow" }}></div> */}
    </div>
  );
};
export const AlsoCheckArt = ({ news = [], authors = [] }) => {
  const [currSlide, setCurrSlide] = useState(0);
  
  const handleNextSlide = () => {
    setCurrSlide((prev) => (prev + 1) % Math.ceil(news.length / 3));
  };
  
  const handlePrevSlide = () => {
    setCurrSlide((prev) => (prev - 1 + Math.ceil(news.length / 3)) % Math.ceil(news.length / 3));
  };
  
  return (
    <div className="asdQWEQWqq">
      <div className="fGwweqqqEQ">
        <span>Also check</span>
        <div></div>
      </div>
      <div className="CxqQEQmn">
        <div className="gradientSldierAlso1"></div>
        {currSlide >= 1 && <div className="gradientSldierAlso2"></div>}
        <div className="dscsOverlay">
          <button className="dcscOvBtn" onClick={() => handlePrevSlide()}>
            {"<"}
          </button>
          <button className="dcscOvBtn" onClick={() => handleNextSlide()}>
            {">"}
          </button>
        </div>
        <div
          className="dascWERW"
          style={{ transform: `translateX(-${currSlide * 430}px)` }}
        >
          {news.map((el, i) => (
            <HubArticle key={el.id} authors={authors} {...el} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const NewsCard = ({ article, author }) => {
  const to = `/article/${article.id}/${article.title.slice(0, -1).replace(/[\s:]+/g, '-').toLowerCase()}`;
  return (
    <Link to={to} className={`news-card${article.img ? " has-img" : ""}`}>
      {article.img && (
        <div className="news-card__img">
          <img src={getImageSrc(article.img)} alt={article.title} />
        </div>
      )}
      <div className="news-card__meta">
        <span className="news-card__date">{article.date}</span>
        {article.category?.slice(0, 2).map((c) => (
          <span key={c} className="tag">{c}</span>
        ))}
      </div>
      <div className="news-card__title">{article.title}</div>
      <p className="news-card__content">{article.content}</p>
      {article.tags?.length > 0 && (
        <div className="news-card__tags">
          {article.tags.map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
      )}
      <div className="news-card__footer">
        <span className="news-card__author">by {author?.nickname || "admin"}</span>
        <span className="sec-eyebrow" style={{ margin: 0 }}>Czytaj →</span>
      </div>
    </Link>
  );
};

export const SuggestedNews = ({ currentArticleId, news: newsData = [], authors: authorsData = [] }) => {
  const suggestedArticles = newsData
    .filter((article) => article.id !== parseInt(currentArticleId))
    .slice(0, 3);

  if (!suggestedArticles.length) return null;

  return (
    <section className="section animate-on-scroll">
      <div className="container">
        <div className="sec-eyebrow" style={{ marginBottom: 24 }}>Polecane artykuły</div>
        <div className="news-grid">
          {suggestedArticles.map((article) => {
            const author = authorsData.find((a) => a.id === article.authorId);
            return <NewsCard key={article.id} article={article} author={author} />;
          })}
        </div>
      </div>
    </section>
  );
};

// DateComponent moved to minor.jsx
// LinkStyled moved to minor.jsx
